import logs from './logs.js'
import activityLogs from './activityLogs.js'

export default {
  logs,
  activityLogs,

  logout: 'Logout',

  // alert title
  alert: {
    unsavedChanges: 'You have unsaved change, are you sure about leaving this page?',
    copy: 'Text copied!',
    duplicateRequest: {
      title: 'Warning',
      message: 'Your previous request is being processed, please wait'
    },
    error: {
      title: 'Error',
      accessDenied: 'Dont have access to this action',
      openingBalanceUnlock: 'Opening balance is unlock, please lock it.',
      openingBalanceLocked: 'Opening balance is locked.',
      contactSupport: 'Contact with support',
      userLimitReached: 'User limit reached',
      documentLimitReached: 'Document limit reached',
      activeSessionLocked: 'Active session locked',
      print: 'The print request has error',
      requiredFieldIsEmpty: 'Required Fields are Missing or is wrong'
    },
    warning: {
      title: 'Warning',
      repeatedRequestText: 'Your previous request is being processed, please wait'
    },
    message: {
      title: 'Message',
      pleaseWait: 'Request sent. please wait...',
      saveChange: 'Change saved'
    }
  },

  global: {
    all: 'All',
    have: 'Have',
    notHave: 'Not have',
    unlimited: 'Unlimited',
    active: 'Active',
    disable: 'Disable',
    free: 'Free',
    dynamicDay: '{num} day | {num} day | {num} days',
    dynamicDayRemaining: '{num} day remaining | {num} day remaining | {num} days remaining',
    today: 'Today',
    yesterday: 'Yesterday',
    bySystem: 'By system',
    dynamicCreate: 'Create {name}',
    confirm: 'Confirm',
    vatInc: 'Vat inc',
    vatExc: 'Vat exc',
    total: 'Total',
    actions: {
      insert: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      trashList: 'Removed list',
      logs: 'Logs',
      exportPdf: 'Export PDF',
      exportExcel: 'Export Excel',
      copy: 'Copy',
      accept: 'Accept',
      menu: 'Menu'
    }
  },

  // mixins
  documentDescriptions: {
    receive: {
      description: 'Receive No. {id}',
      dynamicDescription: 'Receive | {description}'
    },
    payment: {
      description: 'Payment No. {id}',
      dynamicDescription: 'Payment | {description}'
    },
    cost: {
      description: 'Cost No. {id}',
      dynamicDescription: 'Cost | {description}'
    },
    beginningInventory: {
      description: 'Beginning inventory'
    },
    internalFundTransfer: {
      description: 'Withdrawal from {payer} Deposit to {payee}'
    },
    receivePaymentGateway: {
      description: 'Receive payment gateway from {payer} Deposit to {payee}'
    },
    sale: {
      description: 'Sale invoice No. {id}'
    },
    returnSale: {
      description: 'Return sale invoice No. {id}'
    },
    purchase: {
      description: 'Purchase invoice No. {id}'
    },
    returnPurchase: {
      description: 'Return purchase invoice No. {id}'
    },
    warehouse_receipt: {
      on_way_description: 'Pull in for {invoice_type} No. {invoice_id}',
      description: 'Pull in No. {receipt_id}'
    },
    inventory_transfer: {
      description: 'Warehouse transfer No. {receipt_id}'
    },
    warehouse_requisition: {
      waiting_to_send_description: 'Waiting to pull out for {invoice_type} No. {invoice_id}',
      description: 'Pull out No. {receipt_id}',
      description_dynamic: 'Pull out {receipt_id} for {invoice_type} No. {invoice_id}'
    },
    inventory_deficit: {
      description: 'Warehouse deficit No. {id}'
    },
    storeroom_surplus: {
      description: 'Warehouse surplus No. {id}'
    },
    storeroom_conversion: {
      description: 'Warehouse conversion No. {id}'
    },
    sale_cooperation: {
      description: 'Sale cooperation for {invoice_type} No. {invoice_id}'
    },
    purchase_adjustment: {
      description: 'Voided purchase No. {id}'
    },
    return_purchase_adjustment: {
      description: 'Voided purchase refund No. {id}'
    },
    sale_adjustment: {
      description: 'Voided sale No. {id}'
    },
    sale_cooperation_adjustment: {
      description: 'Voided sale cooperation No. {id}'
    },
    return_sale_adjustment: {
      description: 'Voided sale refund No. {id}'
    },
    receive_adjustment: {
      description: 'Voided receive No. {id}'
    },
    payment_adjustment: {
      description: 'Voided payment No. {id}'
    },
    cost_adjustment: {
      description: 'Voided cost No. {id}'
    }
  },

  //invoice types
  invoice_types: {
    1: 'sale invoice',
    2: 'purchase invoice',
    3: 'return sale invoice',
    4: 'return purchase invoice'
  },

  countries: {
    IR: {
      name: 'IRAN',
      provinces: {
        EAZ: 'East Azerbaijan',
        WAZ: 'West Azerbaijan',
        ADL: 'Ardabil',
        ESF: 'Isfahan',
        ABZ: 'Alborz',
        ILM: 'Ilam',
        BHR: 'Bushehr',
        THR: 'Tehran',
        SKH: 'South Khorasan',
        RKH: 'Razavi Khorasan',
        NKH: 'North Khorasan',
        KHZ: 'Khuzestan',
        ZJN: 'Zanjan',
        SMN: 'Semnan',
        SBN: 'Sistan and Baluchestan',
        FRS: 'Fars',
        GZN: 'Qazvin',
        QHM: 'Qom',
        KRD: 'Kurdistan',
        KRN: 'Kerman',
        KRH: 'Kermanshah',
        KBD: 'Kohgiluyeh and Boyer-Ahmad',
        GLS: 'Golestan',
        GIL: 'Gilan',
        LRS: 'Lorestan',
        MZN: 'Mazandaran',
        MKZ: 'Markazi',
        HRZ: 'Hormozgan',
        HDN: 'Hamadan',
        CHB: 'Chaharmahal and Bakhtiari',
        YZD: 'Yazd'
      }
    },
    AE: {
      name: 'United Arab Emirates',
      provinces: {
        AE_AA: 'Al Ain',
        AE_AZ: 'Abu Dhabi Emirate',
        AE_AJ: 'Ajman Emirate',
        AE_DU: 'Dubai',
        AE_FU: 'Fujairah',
        AE_RK: 'Ras al-Khaimah',
        AE_SH: 'Sharjah Emirate',
        AE_UQ: 'Umm al-Quwain'
      }
    },
    KW: {
      name: 'Kuwait',
      provinces: {
        KW_AA: 'Al Asimah',
        KW_HA: 'Hawalli',
        KW_AF: 'Al Farwaniyah',
        KW_MK: 'Mubarak Al-Kabeer',
        KW_AJ: 'Al Jahra',
        KW_AH: 'Al Ahmadi'
      }
    },
    SA: {
      name: 'Saudi Arabia',
      provinces: {
        SA_RH: 'Riyadh',
        SA_MH: 'Makkah',
        SA_AM: 'Al Madinah',
        SA_EP: 'Eastern Province',
        SA_AQ: 'Al-Qassim',
        SA_HI: 'Ha\'il',
        SA_TK: 'Tabuk',
        SA_NB: 'Northern Borders',
        SA_JN: 'Jazan',
        SA_NN: 'Najran',
        SA_AB: 'Al-Bahah Region',
        SA_AJ: 'Al-Jawf',
        SA_AR: 'Asir'
      }
    },
    OM: {
      name: 'Oman',
      provinces: {
        OM_MC: 'Muscat',
        OM_AD: 'Ad Dakhiliyah',
        OM_BN: 'Al Batinah North',
        OM_BS: 'Al Batinah South',
        OM_BU: 'Al Buraymi',
        OM_DH: 'Ad Dhahirah',
        OM_WS: 'Al Wusta',
        OM_MN: 'Musandam',
        OM_SN: 'Ash Sharqiyah North',
        OM_SS: 'Ash Sharqiyah South',
        OM_DO: 'Dhofar'
      }
    },
    BH: {
      name: 'Bahrain',
      provinces: {
        BH_CL: 'Capital',
        BH_SN: 'Southern',
        BH_NN: 'Northern'
      }
    },
    QA: {
      name: 'Qatar',
      provinces: {
        QA_AS: 'Al Shamal',
        QA_AK: 'Al Khor',
        QA_AH: 'Al Shahaniya',
        QA_US: 'Umm Salal',
        QA_AD: 'Al Daayen',
        QA_AW: 'Ad Dawhah',
        QA_AR: 'Al Rayyan',
        QA_AA: 'Al Wakrah'
      }
    }
  },

  currencies: {
    AED: 'AED',
    IRR: 'IRR',
    IRT: 'IRT'
  }
}
